<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Rol" resource="roles" primaryKey="idrol" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" readonly="true" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import RolService from "@/services/rol.service";
import { rol } from "@/models/rol";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: rol,
      service: RolService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        RolService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
